var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:`btn custom-pointer btn-radius ${
    _vm.btnName != '' ? '' : 'akkurate-small'
  } ${_vm.classes}`,staticStyle:{"text-decoration":"none"},attrs:{"to":_vm.to,"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.btnName)+" "),(_vm.icon != '')?_c('font-awesome-icon',{staticClass:"ms-2",attrs:{"icon":['fas', _vm.icon]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }